import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "p-1 w-full flex text-gray-900"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "flex align-middle"
};
import LlTooltip from "@/components/LlTooltip.vue";
import DateRange from "./DateRange.vue";
export default {
  __name: 'SidebarCard',
  props: {
    reportType: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    tooltipData: {
      type: String,
      required: false
    },
    dateRangeOptions: {
      type: Boolean,
      required: false
    },
    generic: {
      type: Boolean,
      required: false
    },
    routeService: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const today = new Date();
    const endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    const dateRangeOptionsList = [{
      id: "thisMonth",
      label: monthString(today.getMonth())
    }, {
      id: "lastMonth",
      label: monthString(endOfPreviousMonth.getMonth())
    }, {
      id: "thisYear",
      label: "YTD"
    }];
    function monthString(month) {
      return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][month];
    }
    const clicked = (id, dateRangeId) => {
      if (props.generic) {
        props.stateParams.dateRangeId = dateRangeId;
        props.routeService.go("reports.generic", {
          id,
          ...dateRangeId
        });
        return;
      }
      props.routeService.go(`reports.${id}`, {
        dateRangeId
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
        class: "grow text-left text-sm font-medium text-gray-500 mr-2 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = $event => clicked(__props.reportType))
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.tooltipData), 1)]),
        _: 1
      })]), __props.dateRangeOptions ? (_openBlock(), _createElementBlock("span", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(dateRangeOptionsList, dateRange => {
        return _createVNode(DateRange, {
          key: dateRange.id,
          dateRange: dateRange,
          reportType: __props.reportType,
          onClicked: clicked
        }, null, 8, ["dateRange", "reportType"]);
      }), 64))])) : (_openBlock(), _createElementBlock("span", _hoisted_3, [_createVNode(DateRange, {
        dateRange: {
          id: undefined,
          label: 'Open'
        },
        reportType: __props.reportType,
        onClicked: clicked
      }, null, 8, ["reportType"])]))]);
    };
  }
};